// extracted by mini-css-extract-plugin
export var active = "_uw-1";
export var circle = "_uw-0";
export var completed = "_uw-2";
export var connector = "_uw-4";
export var connectorCompleted = "_uw-7";
export var connectorSpacer = "_uw-5";
export var iconStrokeOverride = "_uw-8";
export var labelContainer = "_uw-6";
export var pending = "_uw-3";